export default __webpack_public_path__ + "static/media/ic-usd.7b9f4a90.svg";